// extracted by mini-css-extract-plugin
var _1 = "SearchPlatformExternalPlatformTab-module__dismissButton--C85Z_";
export { _1 as "dismissButton" }
